import * as React from "react";
import { useHistory } from "react-router";
import { DefaultButton } from "@fluentui/react/lib/Button";

import LogoImage from "../logo-image-ici/LogoImage";
import { TEXT } from "../../shared/constants/texts";
import { ROUTE } from "../../shared/constants/routes";

const LogOutICI: React.FC = () => {
  const history = useHistory();
  const onloginClickedHandler = async () => {
    history.push({ pathname: ROUTE.LOGIN, state: { fromLogout: true } });
  };

  const imgSrc = "assets/images/icertis-logo/icertis-logo-horiz-on-white-60px.png";

  return (
    <div className="login-container">
      <div>
        <LogoImage logoImage={imgSrc} />
      </div>
      <div className="err-msg-login-button-container">
        <div className="login-button-container">
          <DefaultButton title={TEXT.LOGIN} target="_blank" allowDisabledFocus onClick={onloginClickedHandler}>
            {TEXT.LOGIN}
          </DefaultButton>
        </div>
      </div>
    </div>
  );
};
export default LogOutICI;
